// @codekit-prepend "src/chosen.jquery.min.js", "src/lity.min.js", "src/swiper-bundle.min.js","src/isotope.pkgd.min.js","src/packery-mode.pkgd.js";
jQuery(document).ready(function ($) {

	/**
	 * Hide Register button on mobile when form is in view
	 * NOT NEEDED ANYMORE AS WE REMOVED THE FORM FROM HOME PAGE
	 */
	/* document.addEventListener("DOMContentLoaded", function(){
	const el = document.querySelector('#form')
	const observer = new window.IntersectionObserver(([entry]) => {
	if (entry.isIntersecting) {
		//console.log('ENTER')
		$('.register-btn').fadeOut();
		return
	}
	//console.log('LEAVE')
	$('.register-btn').fadeIn();
	}, {
	root: null,
	threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
	});

	if($('body').hasClass('home') && window.innerWidth < 1024){
		observer.observe(el);
	}
	}) */

	function gup(name) {
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		var regexS = "[\\?&]" + name + "=([^&#]*)";
		var regex = new RegExp(regexS);
		var results = regex.exec(window.location.href);
		if (results == null)
			return "direct";
		else
			return results[1];
	}

	/**
	 * Mapbox
	 */
	if ($("#map").length) {
		const geoLocation = $(".location-map").data("json");

		mapboxgl.accessToken =
			"pk.eyJ1IjoiYnJhbmRmb3JtcHJvamVjdHMiLCJhIjoiY2xhdDV6NmIxMDhrMzNvcWs1Y3ltdXFzZiJ9.SIBCtYwo6PzLATqRghUjdw";

		var map = new mapboxgl.Map({
			container: "map", // container ID
			style: "mapbox://styles/brandformprojects/clebc1bp6000l01p75nilx11d", // style URL
			center: [115.746441864261, -31.832445060725217], // starting position [lng, lat]
			zoom: 13, // starting zoom
		});

		// map.scrollZoom.disable();
		// map.touchZoomRotate.enable();

		map.on("wheel", (event) => {
			if (event.originalEvent.ctrlKey) {
				$(".zoom-tooltip").addClass("hidden");
				return;
			}
			if (event.originalEvent.metaKey) {
				$(".zoom-tooltip").addClass("hidden");
				return;
			}
			if (event.originalEvent.altKey) {
				$(".zoom-tooltip").addClass("hidden");
				return;
			}
			event.preventDefault();
		});

		geoLocation.features.forEach(function (marker) {
			// create a HTML element for each feature
			var el = document.createElement("div");
			el.className = `marker ${marker.colour}`;
			// $(el).data('marker', marker.colour);

			//console.log(marker.properties.image);

			// make a marker for each feature and add it to the map

			const popup = new mapboxgl.Popup({ offset: 0 }).setHTML(
				"<img src=\"" + marker.properties.image + "\">" +
				"<h5>" +
				marker.properties.title.replace("~", "'") +
				"</h5><p>" +
				marker.properties.description.replace("~", "'") +
				"</p>"
			)

			const the_marker = new mapboxgl.Marker(el)
				.setLngLat(marker.geometry.coordinates)
				.setPopup(popup)
				.addTo(map);

			const legendCheckbox = $(".location-map__legends").find(
				`[name=${marker.colour}]`
			);
			$(legendCheckbox)
				.parent()
				.on('click', function () {
					//console.log(marker.colour)
					$(".location-map__legend input").prop("checked", false);
					$(this).children("input").prop("checked", true);
					if (marker.colour == "logo") {
						$(".location-map__map .marker").removeClass('pulse');
						$(".location-map__map .marker:not(.logo)").show();
					} else {
						$(".location-map__map .marker:not(.logo)").removeClass('pulse');
						$(`.location-map__map .marker.${marker.colour}`).addClass('pulse');
						$(".location-map__map .marker:not(.logo)").hide();
						$(`.location-map__map .marker.${marker.colour}`).show();
					}
					$('.mapboxgl-popup').remove();

				});
		});

		$(".location-map__legend input[name='grey']").parent().on('click', function () {
			$(".location-map__legend input").prop("checked", false);
			$(this).children("input").prop("checked", true);
			$(".location-map__map .marker").removeClass('pulse');
			$(".location-map__map .marker:not(.grey)").show();
			$('.mapboxgl-popup').remove();
		});

	}

	// Mapbox Tooltip
	$(".location-map__map").on('hover',
		function () {
			if (!$(".zoom-tooltip").hasClass("hidden")) {
				$(".zoom-tooltip").animate({ opacity: 1 }, 400);
			}
		},
		function () {
			if (!$(".zoom-tooltip").hasClass("hidden")) {
				$(".zoom-tooltip").animate({ opacity: 0 }, 350, function () {
					$(".zoom-tooltip").addClass("hidden");
				});
			}
		}
	);

	$(".location-map__map").mousedown(function () {
		$(".zoom-tooltip").addClass("hidden");
	});

	// if legend items total length is >= to legends wrapper change to flex start
	let legendTotalLength = 0;
	$(".location-map__legend").each(function () {
		legendTotalLength += $(this).width();
	});

	$(window)
		.resize(function () {
			if (legendTotalLength >= $(".location-map__legends").width()) {
				$(".location-map__legends").addClass("justify-content-center spacing");
			} else {
				$(".location-map__legends").removeClass("justify-content-center spacing");
			}
		})
		.resize();

	const viewers = document.querySelectorAll(".image-compare");
	viewers.forEach((element) => {
		let view = new ImageCompare(element,
			{

				// UI Theme Defaults

				controlColor: "#FFFFFF",
				controlShadow: false,
				addCircle: true,
				addCircleBlur: false,

				// Label Defaults

				showLabels: true,
				labelOptions: {
					before: 'Standard',
					after: 'Upgrade',
					onHover: false
				},

				// Smoothing

				smoothing: false,
				smoothingAmount: 100,

				// Other options

				hoverStart: false,
				verticalMode: false,
				startingPoint: 50,
				fluidMode: false
			}
		).mount();
	});

	$(document).on('click', '[data-download]', function (e) {
		let link = $(this).attr('data-download');
		$('#input_2_17').val(link);
	});

	$(document).on('click', '.dynamic-download', function (e) {
		var imgDownloadClick = document.createElement('img');
		imgDownloadClick.height = '1';
		imgDownloadClick.width = '1';
		imgDownloadClick.style.borderStyle = 'none';
		imgDownloadClick.src = 'https://insight.adsrvr.org/track/pxl/?adv=p6f4l5x&ct=0:qa569sw&fmt=3';
		$('body').append(imgDownloadClick);
	});

	$(document).on('click', 'a[download]', function (e) {
		var imgDownloadClick = document.createElement('img');
		imgDownloadClick.height = '1';
		imgDownloadClick.width = '1';
		imgDownloadClick.style.borderStyle = 'none';
		imgDownloadClick.src = 'https://insight.adsrvr.org/track/pxl/?adv=p6f4l5x&ct=0:qa569sw&fmt=3';
		$('body').append(imgDownloadClick);
	});

	$(document).on('gform_confirmation_loaded', function (event, formId) {
		setCookie('ora_registered', 1, 30);

		/* if($('.specifications__downloads_btns').length){
			$('.specifications__downloads_btns a').each(function(){
				let link = $(this).attr('data-download');
				$(this).attr('href', link);
				$(this).prop('download', '');
			});
		} */


		$('.image-and-form__content .text.transition-up, .image-and-form__disclaimer, .popup-form__disclaimer').hide();
		$('.popup-form__content .text.transition-up, .popup-form__disclaimer').hide();
		$('.download-form__disclaimer').hide();

		REA.track_conversion("21077");

		if ($('a[data-download]').length) {
			$('a[data-download]').each(function () {
				let link = $(this).attr('data-download');
				$(this).attr('href', link);
				$(this).prop('download', '');
			});
		}
		var img = document.createElement('img');
		img.height = '1';
		img.width = '1';
		img.style.borderStyle = 'none';
		img.src = 'https://insight.adsrvr.org/track/pxl/?adv=p6f4l5x&ct=0:27fyspj&fmt=3';
		$('body').append(img);

		if (formId == 2) {

			var imgDownload = document.createElement('img');
			imgDownload.height = '1';
			imgDownload.width = '1';
			imgDownload.style.borderStyle = 'none';
			imgDownload.src = 'https://insight.adsrvr.org/track/pxl/?adv=p6f4l5x&ct=0:ynj8uwj&fmt=3';
			$('body').append(imgDownload);

			setTimeout(function () {
				$(document).find('.dynamic-download')[0].click();
			}, 500)
		}
	});

	$('.download-form__form a.close').on('click', function (e) {
		e.preventDefault();
		$('.download-form__wrapper').removeClass('open');
	});

	$('.popup-form a.close').on('click', function (e) {
		e.preventDefault();
		$('.popup-form').removeClass('open');
	});

	$(document).on('click', 'a[href="#download-form"]:not([download])', function (e) {
		e.preventDefault();
		$('.download-form__wrapper').addClass('open');
		if ($('body').hasClass('single-apartments')) {
			$('#input_2_18').val($(this).attr('data-type'));
		}
	});

	//if(!$('body').hasClass('home')){
	$('a[href="#form"]').on('click', function (e) {
		e.preventDefault();
		$('.popup-form').addClass('open');
	});
	/* }else{
		$('a[href="#form"]').on('click', function(e){
			$('html, body').animate(
				{
					scrollTop: $($.attr(this, 'href')).offset().top
				},
				1200
			);
			return false;
		});
	} */


	const number_of_videos = $('.video-accordion__videos .video-accordion__item').length;
	$('body').attr('data-videos', number_of_videos);

	//$('.gfield_select').attr('multiple', 'multiple');
	//$(".gfield_select[multiple='multiple']").chosen({placeholder_text_multiple: 'I am interested in...*'});
	/* $('select#input_1_11').attr('data-placeholder', 'I am looking to');
	$('select#input_1_13').attr('data-placeholder', 'How did you hear about us?');
	$('select#input_1_15').attr('data-placeholder', 'How did you hear about us?'); */
	//$(".ginput_container_select .gfield_select:not([multiple='multiple'])").chosen();

	$('.gfield_select[multiple="multiple"]').attr('data-placeholder', 'I am interested in...*');
	$(".gfield_select[multiple='multiple']").on('change', function (change, deselected) {
		setTimeout(function () {
			$('.chosen-container-multi .chosen-search-input').blur();
		}, 150)
	});

	$(document).on('gform_post_render', function (event, form) {
		//$(".gfield_select[multiple='multiple']").chosen({placeholder_text_multiple: 'I am interested in...*'});
		$('.gfield_select[multiple="multiple"]').attr('data-placeholder', 'I am interested in...*');
		$("#input_3_11, #input_3_15").chosen();
	});


	$('a[href*="#"]').not('a[href="#form"]').not('.close').not('.nav li a').not('[data-lity]').not('[download]').not('[data-download]').click(function () {
		$('html, body').animate(
			{
				scrollTop: $($.attr(this, 'href')).offset().top
			},
			1200
		);
		return false;
	});

	const sections = gsap.utils.toArray('section');

	if (window.scrollY > 0) {
		sections.forEach((section, i) => {
			if (section.getBoundingClientRect().top < window.innerHeight) {
				section.classList.add('in-view');
			}
		});
	}

	if (sections.length) {
		sections[0].classList.add('in-view');
		sections.forEach((section, i) => {
			ScrollTrigger.create({
				trigger: section,
				start: 'top 67%',
				end: 'top top',
				onToggle: () => {
					section.classList.add('in-view');
				}
			});
		});
	}

	if ($('header').hasClass('header--transparent')) {
		$(window).scroll(function () {
			if ($(this).scrollTop() > window.innerHeight) {
				$('header, .header__burger, .register-btn').addClass('scrolled');
			} else {
				$('header, .header__burger, .register-btn').removeClass('scrolled');
			}

		});
	}

	var s = Snap("#nav-bg");

	if (s != null) {
		var nav_bg_frame = s.path('m528,287s-108-5-264-5S0,287,0,287V2S104,0,264,0s264,2,264,2v285Z');
		nav_bg_frame.attr({
			fill: "#06424800",
		});
		var bbox = s.getBBox();
		var viewBox = bbox.x + ' ' + bbox.y + ' ' + bbox.width + ' ' + bbox.height;
		s.attr({
			viewBox: viewBox
		})

		var nav_bg_svg = s.path('m528,18s-108-8-264-8S0,18,0,18V2S104,0,264,0s264,2,264,2v16Z');

		nav_bg_svg.attr({
			fill: "#064248",
			id: "nav_bg_svg",
		});


		//START m528,55S420,6,264,6,0,55,0,55V0h528v55Z
		//2nd m528,73s-108,51-264,51S0,73,0,73V0h528v73Z
		//3rd m528,213s-108-59-264-59S0,213,0,213V0h528v213Z
		//OLD//MIDDLE m528,125s-108,31-264,31S0,125,0,125V0h528v125Z
		//ENDING m528,285s-108,1-264,1S0,285,0,285V0h528v285Z
		var anims = [
			function () {
				nav_bg_svg.animate({ d: "m528,118s-108,52-264,52S0,118,0,118V2S104,0,264,0s264,2,264,2v116Z" }, 450, mina.easeout, anims[1]);
			},
			function () {
				nav_bg_svg.animate({ d: "m528,288s-108,2-264,2S0,288,0,288V2S104,0,264,0s264,2,264,2v286Z" }, 1100, mina.backout);
			}
		];

		/* var animsReverse = [
			function(){
				nav_bg_svg.animate({ d: "m528,118s-108,52-264,52S0,118,0,118V2S104,0,264,0s264,2,264,2v116Z" }, 450, mina.easeout, animsReverse[1] );
			},
			function(){
				nav_bg_svg.animate({ d: "m528,18s-108-8-264-8S0,18,0,18V2S104,0,264,0s264,2,264,2v16Z" }, 450, mina.easein );
			}
		]; */


		$('.header__burger').click(function () {

			if ($(this).hasClass('active')) {
				//alert('has')
				//nav_bg_svg.animate({ d: "m528,24s-108,10-264,10S0,24,0,24V0h528v24Z" }, 2000, mina.backout );
				//setTimeout(function(){
				//animsReverse[0]();
				//nav_bg_svg.animate({ d: "m528,18s-108-8-264-8S0,18,0,18V2S104,0,264,0s264,2,264,2v16Z" }, 10, mina.linear );
				//animsReverse[1]();
				//},150)
				//s.path('m528,18s-108-8-264-8S0,18,0,18V2S104,0,264,0s264,2,264,2v16Z');
				/* nav_bg_svg.attr({
					fill: "#06424800",
				});
				nav_bg_svg.attr('d', 'm528,18s-108-8-264-8S0,18,0,18V2S104,0,264,0s264,2,264,2v16Z') */

			} else {
				nav_bg_svg.attr('d', 'm528,18s-108-8-264-8S0,18,0,18V2S104,0,264,0s264,2,264,2v16Z')
				nav_bg_svg.attr({
					fill: "#064248",
				});
				anims[0]();
				//setTimeout(function(){
				//	anims[1]();
				//},250)
				//nav_bg_svg.animate({ d: "m528,305s-108-39-264-39S0,305,0,305V0h528v305Z" }, 2000, mina.backout);
			}
			$(this).toggleClass('active');
			$('.header,.nav, .register-btn').toggleClass('active');

		})
	}

	$('.video-accordion__item').click(function (e) {
		if (!$(this).hasClass('active') && window.innerWidth >= 1024) {
			$('.video-accordion__item').removeClass('active');
			$(this).addClass('active');
		} else {
			const href = $(this).find('.play').data('video');
			if (href) {
				const lightbox = lity(href);
			}

		}

	});
	$('.video-accordion__item').mouseover(function () {
		if (!$(this).hasClass('active') && window.innerWidth >= 1024) {
			$('.video-accordion__item').removeClass('active');
			$(this).addClass('active');
		}
	});


	$(document).on('gform_post_render', function (event, form_id, current_page) {

		// * --------- Postcode Search ------------
		// - Requirements - jQuery Debounce function to prevent input overload or you could just setup a timeout/interval function...
		if ($('.postcode-searcher').length) {


			$('.postcode-searcher input').hide();
			$('.postcode-searcher').append('<input type="text" class="postcode-searcher__input" placeholder="Postcode*" />');

			if ($('.postcode-searcher .ginput_container input').val()) {
				$('.postcode-searcher__input').val($('.postcode-searcher .ginput_container input').val());
			}

			let currentVal = '';
			$('.postcode-searcher .postcode-searcher__input').keyup(debounce(async function (e) {
				const suggestionLimit = 10;
				const val = e.target.value;

				await getSuburb(val).then((res) => {
					const { suburbs } = JSON.parse(res);

					if (!$('.postcode-searcher .suggestions').length) {
						$('.postcode-searcher').append('<div class="suggestions"></div>');
					}

					$('.postcode-searcher .suggestions').html('');

					if (suburbs) {
						suburbs.slice(0, suggestionLimit).forEach((suburb) => {
							$('.postcode-searcher .suggestions').append(`<div class="suggestion">${suburb.postcode}, ${suburb.name}</div>`);
						});


						$('.postcode-searcher .suggestions').show();

						$('.postcode-searcher .suggestion').click(function () {
							if (suburbs.length) {
								$('.postcode-searcher .suggestion').removeClass('active');
								$(this).addClass('active');
								$('.postcode-searcher input').val($(this).text());
								$('.postcode-searcher .suggestions').hide();
								currentVal = $(this).text();
							}
						});

						$(document).click(function (e) {
							if (!$(e.target).closest('.postcode-searcher').length) {
								$('.postcode-searcher .suggestions').hide();
							}
						});

						$('.postcode-searcher input').click(function () {
							if ($(this).val() !== '') {
								$('.postcode-searcher .suggestions').show();
							}
						});
					}

					// console.log('currentVal:' + currentVal);
					// console.log('selected Val:' + $('.postcode-searcher .postcode-searcher__input').val());
					if (!suburbs && val.length >= 4 && currentVal !== $('.postcode-searcher .ginput_container input').val()) {
						$('.postcode-searcher .suggestions').html('<div class="suggestion">No results found</div>');
						$('.postcode-searcher .suggestions').show();
						$('.postcode-searcher .ginput_container input').val('');
					}

				});
			}, 150));
		}

	});


	// Video accordion
	if ($('.video-accordion__item a').length) {
		$('.video-accordion__item a').click(function (e) {
			e.preventDefault();
			const id = $(this).attr('href');
			const gallery = $(id);

			if (gallery.find('.swiper-slide-active video').length) {
				gallery.find('.swiper-slide-active video').get(0).play();
			}

			gallery.addClass('active');
		});
	}

	// Video accordion - Popup Gallery Setup
	if ($('.popup-gallery__content-slider').length) {
		let swiper;
		$('.popup-gallery__content-slider').each(function () {
			swiper = new Swiper(this, {
				threshold: 10,
				navigation: {
					nextEl: '.swiper-button-next.swiper-button-next-popup',
					prevEl: '.swiper-button-prev.swiper-button-prev-popup',
				},
				keyboard: {
					enabled: true,
				},
				on: {
					transitionStart: function () {

						var videos = document.querySelectorAll('video:not(.autoplaying)');

						Array.prototype.forEach.call(videos, function (video) {
							video.pause();
						});
					},

					transitionEnd: function () {

						var activeIndex = this.activeIndex;
						var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
						var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
						if (activeSlideVideo) {
							activeSlideVideo.play();
						}

					},

				}
			});
		})

		$('.popup-gallery__close').click(function () {
			if ($('.popup-gallery.active .popup-gallery__content-slider .swiper-slide-active video').length) {
				$('.popup-gallery.active .popup-gallery__content-slider .swiper-slide-active video').get(0).pause();
			}

			$(this).closest('.popup-gallery').removeClass('active');

		});

		$('.gallery__image').on('click', function (e) {
			e.preventDefault();

			const index = $(this).attr('data-index');
			//console.log(index);
			const gallery = $(this).closest('section').find('.popup-gallery');

			$('a.test').click(function () {
				var slideIndex = $(this).closest('.slide').index('.slide');
				alert(slideIndex);
			});

			swiper.slideTo(index, 0);

			if ($('.popup-gallery__content-slider .swiper-slide-active video').length && index === swiper.activeIndex) {
				$('.popup-gallery__content-slider .swiper-slide-active video').get(0).play();
			}

			gallery.addClass('active');

		});


		$('.gallery-grid__item-hover,.gallery-grid__item-hover a').click(function (e) {
			e.preventDefault();

			const index = $(this).closest('.gallery-grid__item').index('.gallery-grid__item');
			const gallery = $('.popup-gallery');

			swiper.slideTo(index, 0);

			if ($('.popup-gallery__content-slider .swiper-slide-active video').length && index === swiper.activeIndex) {
				$('.popup-gallery__content-slider .swiper-slide-active video').get(0).play();
			}

			gallery.addClass('active');

		});

		if (gup('video') != 'direct') {

			const index = parseInt(gup('video') - 1) || 0;

			const gallery = $('.popup-gallery');

			swiper.slideTo(index, 0);

			if ($('.popup-gallery__content-slider .swiper-slide-active video').length && index === swiper.activeIndex) {

				$('.popup-gallery__content-slider .swiper-slide-active video').get(0).play();
			}

			gallery.addClass('active');

		}


		swiper.on('slideChangeTransitionEnd', function () {
			$('.popup-gallery__content-slider .swiper-slide video').each(function () {
				$(this).get(0).pause();
				$(this).get(0).currentTime = 0;
			});

			if ($('.popup-gallery__content-slider .swiper-slide-active video').length) {
				$('.popup-gallery__content-slider .swiper-slide-active video').get(0).play();
			}
		});
	}

	// Gallery Grid
	if ($('.gallery-grid').length) {
		$('.gallery-grid').isotope({
			// set itemSelector so .grid-sizer is not used in layout
			itemSelector: '.gallery-grid__item',
			percentPosition: true,
			layoutMode: 'packery',
			packery: {
				gutter: '.gutter-sizer'
			},
		})
	}

	// on video load in the gallery grid
	$('.gallery-grid__item video').on('loadeddata', function () {
		$('.gallery-grid').isotope('layout');
	});

	/////////////////////////////////////////////////////////////////////////
	//// Apartment selector page
	let swiperOptions = {
		loopedSlides: 8,
		slidesPerView: 'auto',
		freeMode: true,
		spaceBetween: 30,
		mousewheel: false,
		allowTouchMove: false
	};

	if (window.innerWidth < 1024) {
		swiperOptions = {
			// loopedSlides: 8,
			// slidesPerView: 'auto',
			spaceBetween: 30,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		};
	}

	if ($('.video-and-heading__horizontal-scroller').length) {
		const swiper = new Swiper('.video-and-heading__horizontal-scroller', swiperOptions);

		// let offset = ($('.video-and-heading .container-right').outerHeight() - window.innerHeight - $('header').outerHeight()) / 2;

		let number_of_slides = $(this).find('.swiper-slide').length * 500;
		let offset = -20;
		const mm = gsap.matchMedia();

		mm.add("(min-width: 1024px)", () => {
			ScrollTrigger.create({
				trigger: '.video-and-heading .container-full',
				start: `top+=${offset}px top+=${$('header').outerHeight()}`,
				end: `bottom+=${number_of_slides}px top`,
				//markers: true,
				pin: true,
				onUpdate: function (self) {
					swiper.setProgress(self.progress, 300)
				}
			});


			$('.video-and-heading .swiper-slide').each(function () {
				const _this = $(this);

				let mouse = { x: 0, y: 0 };
				_this.mousemove(e => {

					mouse.x = getCursorPos(e, _this.find('.video-and-heading__video')).x;
					mouse.y = getCursorPos(e, _this.find('.video-and-heading__video')).y;

					gsap.to('.video-and-heading__play', {
						duration: 0.25,
						overwrite: "auto",
						x: mouse.x,
						y: mouse.y,
						//stagger: 0.08,
						ease: "power2.out"
					})

				});
			});


		});
	}

	if ($('.single-image__play').length) {



		const mm = gsap.matchMedia();

		mm.add("(min-width: 1024px)", () => {

			$('.single-image').each(function () {
				const _this = $(this);

				let mouse = { x: 0, y: 0 };
				_this.mousemove(e => {

					mouse.x = getCursorPos(e, _this.find('.single-image__block')).x;
					mouse.y = getCursorPos(e, _this.find('.single-image__block')).y;

					gsap.to('.single-image__play', {
						duration: 0.25,
						overwrite: "auto",
						x: mouse.x,
						y: mouse.y,
						//stagger: 0.08,
						ease: "power2.out"
					})

				});
			});


		});
	}

	if ($('.gallery-horizontal-scroll__horizontal-scroller').length) {


		let number_of_slides = $(this).find('.swiper-slide').length * 500;
		let offset = -30;
		const mm = gsap.matchMedia();

		mm.add("(min-width: 1024px)", () => {
			const swiper = new Swiper('.gallery-horizontal-scroll__horizontal-scroller', swiperOptions);
			ScrollTrigger.create({
				trigger: '.gallery-horizontal-scroll .container-right',
				start: `top+=${offset}px top+=${$('header').outerHeight()}`,
				end: `bottom+=${number_of_slides}px top`,
				//markers: true,
				pin: true,
				onUpdate: function (self) {
					swiper.setProgress(self.progress, 300)
				}
			})
		});
	}

	/////////////////////////////////////////////////////////////////////////
	//// Apartment selector page
	if ($('.apartment-selector').length) {
		$('.apartment-selector__block[data-button]').click(function () {
			if ($(this).data('button') === 'bedrooms') {
				$('.apartment-selector__starter').hide();
				$('.apartment-selector__bedrooms').show();
			} else if ($(this).data('button') === 'aspects') {
				$('.apartment-selector__starter').hide();
				$('.apartment-selector__aspects').show();
			}
		});

		$('.apartment-selector__return').click(function (e) {
			e.preventDefault();

			if ($('.apartment-selector__starter').css('display') === 'block') {
				window.history.back();

			} else if ($('.apartment-selector__bedrooms').css('display') === 'block' || $('.apartment-selector__aspects').css('display') === 'block') {
				$('.apartment-selector__bedrooms').hide();
				$('.apartment-selector__aspects').hide();
				$('.apartment-selector__starter').show();
			}

		})
	}

	/////////////////////////////////////////////////////////////////////////
	//// Single Apartment Popup

	if ($('.single-apartment__gallery').length) {
		$(document).on('lity:open', function (event, instance) {
			const swiper = new Swiper('.single-apartment__gallery', {
				spaceBetween: window.innerWidth >= 1024 ? 50 : 20,
				autoHeight: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		});
	}

	/////////////////////////////////////////////////////////////////////////
	//// AJAX Form
	if ($('form.explore-residences__filter').length) {
		$('form.explore-residences__filter input').bind('change', $.debounce(400, function () {
			const serializedData = $('form.explore-residences__filter').serialize();

			console.log(serializedData)
			window.history.pushState(null, null, '?' + serializedData);

			if (window.location.href.indexOf('page/') > -1 && window.location.href.indexOf('page/1') === -1) {
				window.location.href = window.location.href.replace(/page\/\d+/, '');
				return;
			}


			$.ajax({
				type: 'POST',
				url: ora_admin.ajax_url,
				data: {
					action: 'ajax_get_apartments',
					form_data: serializedData
				},
				beforeSend: function () {
					// clear .explore-residences__list
					$('.explore-residences__list').html(`
					<div class="ajax-loader">
						<svg version="1.1" id="L4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
							<circle fill="#001618" stroke="none" cx="6" cy="50" r="6">
								<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"></animate>
							</circle>
							<circle fill="#001618" stroke="none" cx="26" cy="50" r="6">
								<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"></animate>
							</circle>
							<circle fill="#001618" stroke="none" cx="46" cy="50" r="6">
								<animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"></animate>
							</circle>
						</svg>
					</div>`);
				},
				success: function (res) {
					const apartments = JSON.parse(res);
					$('.explore-residences__list').html(apartments.html);

					$('.explore-residences__apt-found span').text(apartments.apartments_found ? apartments.apartments_found : 0);
				},
				error: function (err) {
					console.error(err);
				}
			})
		}));


		$('.explore-residences__filter-reset button').click(function (e) {
			e.preventDefault();
			$('.explore-residences__filter input').prop('checked', false);
			$('.explore-residences__filter input').trigger('change');
		});
	}

	/////////////////////////////////////////////////////////////////////////
	//// Interactive image


	if ($('.taxonomy-aspects .taxonomy-aspects__building').length) {
		let interactionType = 'hover';

		if ($('.taxonomy-aspects').hasClass('tv')) {
			interactionType = 'tap';
		}


		new InteractiveImage({
			svg: '.taxonomy-aspects svg',
			polygons: '.taxonomy-aspects svg polygon',
			labels: '.taxonomy-aspects .taxonomy-aspects__interactive-label',
			taxonomy: 'level',
			centreYOnly: true,
			interactionType: interactionType
		});

	}

	if ($('.taxonomy-level .taxonomy-level__floorplate').length) {
		new InteractiveImage({
			svg: '.taxonomy-level svg',
			polygons: '.taxonomy-level svg polygon',
			labels: '.taxonomy-level .taxonomy-level__interactive-label',
			taxonomy: 'apt',
			interactionType: 'click'
		});
	}

	if ($('.explore-residences__filter-btn').length) {
		$('.explore-residences__filter-btn').click(function (e) {
			e.preventDefault();

			$(this).parent().next().toggleClass('active');
		})
	}

	if ($('.explore-residences__filter-option input').length) {
		$('.explore-residences__filter-options').each(function () {
			const selected = $(this).find('input:checked').map(function () {
				return $(this).val();
			}).get().join(', ');

			$(this).prev().find('.explore-residences__filter-selected span').text(selected);
		});

		$('.explore-residences__filter-option input').change(function () {
			const selected = $(this).parent().parent().find('input:checked').map(function () {
				return $(this).val();
			}).get().join(', ');

			$(this).parent().parent().prev().find('.explore-residences__filter-selected span').text(selected);
		});
	}

	/////////////////////////////////////////////////////////////////////////
	//// Schemes

	if ($('.schemes').length) {
		$('.schemes__filter-location input').change(function () {
			$('.schemes__filter-location input').not(this).prop('checked', false);
		});

		$('.schemes__filter-schemes input').change(function () {
			$('.schemes__filter-schemes input').not(this).prop('checked', false);
		});

		$('.schemes__filter input').change(function () {
			updateSelectedScheme();
		});

		updateSelectedScheme();

		function updateSelectedScheme() {
			const location = $('.schemes__filter-location input:checked').val();
			const scheme = $('.schemes__filter-schemes input:checked').val();

			$('.schemes__images img').removeClass('active');

			$('.schemes__images img').each(function () {
				if ($(this).hasClass(location) && $(this).hasClass(scheme)) {
					$(this).addClass('active');
				}
			});
		}

	}

	/////////////////////////////////////////////////////////////////////////
	//// Gallery

	if ($('.gallery').length) {
		$('.gallery__images').each(function () {
			const swiper = new Swiper(this, {
				slidesPerView: 'auto',
				spaceBetween: window.innerWidth >= 1024 ? 50 : 20,
				navigation: {
					nextEl: '.swiper-button-next.swiper-button-next-gallery',
					prevEl: '.swiper-button-prev.swiper-button-prev-gallery',
				},
			});
		})
	}

	/////////////////////////////////////////////////////////////////////////
	//// CSS variable setter

	webHeight();
	if (window.innerWidth >= 1024) {
		window.addEventListener('resize', webHeight);
	}

	if ($('body').hasClass('single-apartments') && $('body').hasClass('is-tv')) {
		const apt_no = $('article').attr('data-apt-number');
		const light_type = $('article').attr('data-light-type');
		allOff().then(function () {
			if (light_type == 'single') {
				console.log('Turning on Apartment ' + apt_no);
				turnOnApt(apt_no);
			} else {
				console.log('Turning on group Apartment' + apt_no);
				turnOnLevel('Apartment' + apt_no);
			}
		})
	}

	if ($('body').hasClass('page-template-template-apartment-selector') && $('body').hasClass('is-tv')) {
		allOn();
	}

	if ($('body').hasClass('tax-level') && $('body').hasClass('is-tv')) {
		const level_no = $('.taxonomy-level').attr('data-level');
		allOff().then(function () {
			console.log('Turning on level ' + level_no);
			turnOnLevel('Level' + level_no);
		})
	}

	if ($('body').hasClass('page-template-template-explore-residences') && $('body').hasClass('is-tv')) {
		const bedrooms_no = $('.explore-residences').attr('data-bedrooms');
		allOff().then(function () {
			console.log('Turning on group Bedrooms' + bedrooms_no);
			turnOnLevel('Bedrooms' + bedrooms_no);
		})
	}

});

// * Safari height issues for iPad and iPhones
const doc = document.documentElement;
function webHeight() {
	const headerHeight = jQuery('header').outerHeight(true);
	doc.style.setProperty('--header-height', `${headerHeight}px`);
	doc.style.setProperty('--vp-height', `${window.innerHeight}px`);
}

function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}
function eraseCookie(name) {
	document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function getMousePosition(el) {
	if (event.pageX < $(el).offset().left + $(el).width() / 2) {
		return 'left';
	} else {
		return 'right';
	}
}

function debounce(func, timeout = 300) {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => { func.apply(this, args); }, timeout);
	};
}

async function getSuburb(postcode) {
	// console.log(postcode);
	return await jQuery.ajax({
		url: ajax_admin.ajaxurl,
		type: 'POST',
		data: {
			action: 'get_suburb_via_postcode',
			postcode: postcode
		},
		success: function (res) {
			// console.log(res);
			return res;
		}
	});

}


// If it ain't centering correctly, look into the other equations here:
// https://en.wikipedia.org/wiki/Centroid#Of_a_polygon

function getPolygonCentroid(pts) {
	pts = pts.split(' ').map(function (p) { let xy = p.split(','); return { x: parseInt(xy[0]), y: parseInt(xy[1]) }; });

	let first = pts[0], last = pts[pts.length - 1];
	if (first.x != last.x || first.y != last.y) pts.push(first);
	let twicearea = 0,
		x = 0, y = 0,
		nPts = pts.length,
		p1, p2, f;
	for (let i = 0, j = nPts - 1; i < nPts; j = i++) {
		p1 = pts[i]; p2 = pts[j];
		f = p1.x * p2.y - p2.x * p1.y;
		twicearea += f;
		x += (p1.x + p2.x) * f;
		y += (p1.y + p2.y) * f;
	}
	f = twicearea * 3;
	return { x: x / f, y: y / f };
}



class InteractiveImage {
	constructor({ svg, polygons, labels, taxonomy, centreYOnly = false, interactionType = 'hover' }) {
		this.svg = document.querySelector(svg)
		this.polygons = document.querySelectorAll(polygons);
		this.labels = document.querySelectorAll(labels);
		this.taxonomy = taxonomy;
		this.centreYOnly = centreYOnly;

		const viewBox = this.svg.getAttribute('viewBox').split(' ');
		this.svgWidth = viewBox[2];
		this.svgHeight = viewBox[3];
		this.interactionType = interactionType;
		this.mouseEvents = {}

		if (interactionType === 'hover' || interactionType === 'tap') {
			this.mouseEvents = {
				active: 'mouseenter',
				unactive: 'mouseleave'
			}
		} else if (interactionType === 'click') {
			this.mouseEvents = {
				active: 'click',
				unactive: 'click',
			}
		}

		// TODO: clean up the init function (maybe move most of the code to their individual functions)
		this.init();
		// this.mouseEvents();
	}

	init() {
		const self = this;

		if (this.polygons.length) {
			this.polygons.forEach(function (polygon) {
				const points = polygon.getAttribute('points');
				const level = polygon.getAttribute(`data-${self.taxonomy}`);
				const url = polygon.getAttribute('data-url');
				const { x, y } = getPolygonCentroid(points);

				const xPercent = x / self.svgWidth * 100;
				const yPercent = y / self.svgHeight * 100;

				const label = Array.from(self.labels).find((label) => label.getAttribute(`data-${self.taxonomy}`) === level);

				if (!self.centreYOnly) {
					label.style.left = `${xPercent}%`;
				}

				label.style.top = `${yPercent}%`;

				label.classList.add('positioned');

				if (self.interactionType === 'hover') {
					polygon.addEventListener('click', function () {
						window.location.href = url;
					})

				} else if (self.interactionType === 'tap') {
					polygon.addEventListener('click', function () {

						const level = polygon.getAttribute('data-level-label');

						Array.from(self.polygons).filter((p) => p !== polygon).forEach((p) => {
							p.classList.remove('clicked');
						})

						if (polygon.classList.contains('clicked')) {
							window.location.href = url;
						} else {
							polygon.classList.add('clicked');

							allOff().then(function () {
								turnOnLevel(level);
							})
						}
					})
				}

				polygon.addEventListener(self.mouseEvents.active, function () {
					label.classList.add('active');
					polygon.classList.add('active');
				});

				if (self.mouseEvents.active !== 'click') {
					polygon.addEventListener(self.mouseEvents.unactive, function (e) {
						label.classList.remove('active');
						polygon.classList.remove('active');

						if (self.interactionType === 'tap') {
							polygon.classList.remove('clicked');
						}

					});
				}


				label.addEventListener(self.mouseEvents.active, function (e) {
					label.classList.add('active');
					polygon.classList.add('active');
				});


				label.addEventListener('click', function (e) {
					if (label.classList.contains('active')) {
						const link = label.querySelector('.apt-info__link a');
						if (link) {
							link.click();
						}
					}
				})

				if (self.mouseEvents.active !== 'click') {
					label.addEventListener(self.mouseEvents.unactive, function () {
						label.classList.remove('active');
						polygon.classList.remove('active');
					});

				} else {
					document.addEventListener('click', function (e) {
						if (!label.contains(e.target) && !polygon.contains(e.target)) {
							label.classList.remove('active');
							polygon.classList.remove('active');
						}
					});

					// if(label.querySelector('.close').length) {
					// 	label.querySelector('.close').addEventListener('click',function() {
					// 		label.classList.remove('active');
					// 	})
					// }
				}

			});
		}
	}
}


class ImageCompare {
	constructor(el, settings = {}) {
		const defaults = {
			controlColor: "#FFFFFF",
			controlShadow: true,
			addCircle: false,
			addCircleBlur: true,
			showLabels: false,
			labelOptions: {
				before: "Before",
				after: "After",
				onHover: false,
			},
			smoothing: true,
			smoothingAmount: 100,
			hoverStart: false,
			verticalMode: false,
			startingPoint: 50,
			fluidMode: false,
		};

		this.settings = Object.assign(defaults, settings);

		this.safariAgent =
			navigator.userAgent.indexOf("Safari") != -1 &&
			navigator.userAgent.indexOf("Chrome") == -1;

		this.el = el;
		this.images = {};
		this.wrapper = null;
		this.control = null;
		this.arrowContainer = null;
		this.arrowAnimator = [];
		this.active = false;
		this.slideWidth = 50;
		this.lineWidth = 2;
		this.arrowCoordinates = {
			circle: [5, 3],
			standard: [8, 0],
		};
	}

	mount() {
		// Temporarily disable Safari smoothing
		if (this.safariAgent) {
			this.settings.smoothing = false;
		}

		this._shapeContainer();
		this._getImages();
		this._buildControl();
		this._events();
	}

	_events() {
		let bodyStyles = `

	  `;

		// Desktop events
		this.el.addEventListener("mousedown", (ev) => {
			this._activate(true);
			document.body.classList.add("icv__body");
			//disableBodyScroll(this.el, {reserveScrollBarGap: true});
			this._slideCompare(ev);
		});
		this.el.addEventListener(
			"mousemove",
			(ev) => this.active && this._slideCompare(ev)
		);

		this.el.addEventListener("mouseup", () => this._activate(false));
		document.body.addEventListener("mouseup", () => {
			document.body.classList.remove("icv__body");
			//enableBodyScroll(this.el);
			this._activate(false);
		});

		// Mobile events

		this.control.addEventListener("touchstart", (e) => {
			this._activate(true);
			document.body.classList.add("icv__body");
			//disableBodyScroll(this.el, {reserveScrollBarGap: true});
		});

		this.el.addEventListener("touchmove", (ev) => {
			this.active && this._slideCompare(ev);
		});
		this.el.addEventListener("touchend", () => {
			this._activate(false);
			document.body.classList.remove("icv__body");
			//enableBodyScroll(this.el);
		});

		// hover

		this.el.addEventListener("mouseenter", () => {
			this.settings.hoverStart && this._activate(true);
			let coord = this.settings.addCircle
				? this.arrowCoordinates.circle
				: this.arrowCoordinates.standard;

			this.arrowAnimator.forEach((anim, i) => {
				anim.style.cssText = `
		  ${this.settings.verticalMode
						? `transform: translateY(${coord[1] * (i === 0 ? 1 : -1)}px);`
						: `transform: translateX(${coord[1] * (i === 0 ? 1 : -1)}px);`
					}
		  `;
			});
		});

		this.el.addEventListener("mouseleave", () => {
			let coord = this.settings.addCircle
				? this.arrowCoordinates.circle
				: this.arrowCoordinates.standard;

			this.arrowAnimator.forEach((anim, i) => {
				anim.style.cssText = `
		  ${this.settings.verticalMode
						? `transform: translateY(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`
						});`
						: `transform: translateX(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`
						});`
					}
		  `;
			});
		});
	}

	_slideCompare(ev) {
		let bounds = this.el.getBoundingClientRect();
		let x =
			ev.touches !== undefined
				? ev.touches[0].clientX - bounds.left
				: ev.clientX - bounds.left;
		let y =
			ev.touches !== undefined
				? ev.touches[0].clientY - bounds.top
				: ev.clientY - bounds.top;

		let position = this.settings.verticalMode
			? (y / bounds.height) * 100
			: (x / bounds.width) * 100;

		if (position >= 0 && position <= 100) {
			this.settings.verticalMode
				? (this.control.style.top = `calc(${position}% - ${this.slideWidth / 2
					}px)`)
				: (this.control.style.left = `calc(${position}% - ${this.slideWidth / 2
					}px)`);

			if (this.settings.fluidMode) {
				this.settings.verticalMode
					? (this.wrapper.style.clipPath = `inset(0 0 ${100 - position}% 0)`)
					: (this.wrapper.style.clipPath = `inset(0 0 0 ${position}%)`);
			} else {
				this.settings.verticalMode
					? (this.wrapper.style.height = `calc(${position}%)`)
					: (this.wrapper.style.width = `calc(${100 - position}%)`);
			}
		}
	}

	_activate(state) {
		this.active = state;
	}

	_shapeContainer() {
		let imposter = document.createElement("div");
		let label_l = document.createElement("span");
		let label_r = document.createElement("span");

		label_l.classList.add("icv__label", "icv__label-before", "keep");
		label_r.classList.add("icv__label", "icv__label-after", "keep");

		if (this.settings.labelOptions.onHover) {
			label_l.classList.add("on-hover");
			label_r.classList.add("on-hover");
		}

		if (this.settings.verticalMode) {
			label_l.classList.add("vertical");
			label_r.classList.add("vertical");
		}

		label_l.innerHTML = this.settings.labelOptions.before || "Before";
		label_r.innerHTML = this.settings.labelOptions.after || "After";

		if (this.settings.showLabels) {
			this.el.appendChild(label_l);
			this.el.appendChild(label_r);
		}

		this.el.classList.add(
			`icv`,
			this.settings.verticalMode
				? `icv__icv--vertical`
				: `icv__icv--horizontal`,
			this.settings.fluidMode ? `icv__is--fluid` : `standard`
		);

		imposter.classList.add("icv__imposter");

		this.el.appendChild(imposter);
	}

	_buildControl() {
		let control = document.createElement("div");
		let uiLine = document.createElement("div");
		let arrows = document.createElement("div");
		let circle = document.createElement("div");

		const arrowSize = "20";

		arrows.classList.add("icv__theme-wrapper");

		for (var idx = 0; idx <= 1; idx++) {
			let animator = document.createElement(`div`);

			let arrow = `<svg
		height="15"
		width="15"
		 style="
		 transform:
		 scale(${this.settings.addCircle ? 0.7 : 1.5})
		 rotateZ(${idx === 0
					? this.settings.verticalMode
						? `-90deg`
						: `180deg`
					: this.settings.verticalMode
						? `90deg`
						: `0deg`
				}); height: ${arrowSize}px; width: ${arrowSize}px;

		 ${this.settings.controlShadow
					? `
		 -webkit-filter: drop-shadow( 0px 3px 5px rgba(0, 0, 0, .33));
		 filter: drop-shadow( 0px ${idx === 0 ? "-3px" : "3px"
					} 5px rgba(0, 0, 0, .33));
		 `
					: ``
				}
		 "
		 xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 15 15">
		 <path ${this.settings.addCircle
					? `fill="transparent"`
					: `fill="${this.settings.controlColor}"`
				}
		 stroke="${this.settings.controlColor}"
		 stroke-linecap="round"
		 stroke-width="${this.settings.addCircle ? 3 : 0}"
		 d="M4.5 1.9L10 7.65l-5.5 5.4"
		 />
	   </svg>`;

			animator.innerHTML += arrow;
			this.arrowAnimator.push(animator);
			arrows.appendChild(animator);
		}

		let coord = this.settings.addCircle
			? this.arrowCoordinates.circle
			: this.arrowCoordinates.standard;

		this.arrowAnimator.forEach((anim, i) => {
			anim.classList.add("icv__arrow-wrapper");

			anim.style.cssText = `
		${this.settings.verticalMode
					? `transform: translateY(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`
					});`
					: `transform: translateX(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`
					});`
				}
		`;
		});

		control.classList.add("icv__control");

		control.style.cssText = `
	  ${this.settings.verticalMode ? `height` : `width `}: ${this.slideWidth}px;
	  ${this.settings.verticalMode ? `top` : `left `}: calc(${this.settings.startingPoint
			}% - ${this.slideWidth / 2}px);
	  ${"ontouchstart" in document.documentElement
				? ``
				: this.settings.smoothing
					? `transition: ${this.settings.smoothingAmount}ms ease-out;`
					: ``
			}
	  `;

		uiLine.classList.add("icv__control-line");

		uiLine.style.cssText = `
		${this.settings.verticalMode ? `height` : `width `}: ${this.lineWidth}px;
		background: ${this.settings.controlColor};
		  ${this.settings.controlShadow
				? `box-shadow: 0px 0px 15px rgba(0,0,0,0.33);`
				: ``
			}
	  `;

		let uiLine2 = uiLine.cloneNode(true);

		circle.classList.add("icv__circle");
		circle.style.cssText = `

		${this.settings.addCircleBlur &&
			`-webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px)`
			};

		border: ${this.lineWidth}px solid ${this.settings.controlColor};
		${this.settings.controlShadow &&
			`box-shadow: 0px 0px 15px rgba(0,0,0,0.33)`
			};
	  `;

		control.appendChild(uiLine);
		this.settings.addCircle && control.appendChild(circle);
		control.appendChild(arrows);
		control.appendChild(uiLine2);

		this.arrowContainer = arrows;

		this.control = control;
		this.el.appendChild(control);
	}

	_getImages() {
		let children = this.el.querySelectorAll("img, video, .keep");
		this.el.innerHTML = "";
		children.forEach((img) => {
			this.el.appendChild(img);
		});

		let childrenImages = [...children].filter(
			(element) => ["img", "video"].includes(element.nodeName.toLowerCase())
		);

		//  this.settings.verticalMode && [...children].reverse();
		this.settings.verticalMode && childrenImages.reverse();

		for (let idx = 0; idx <= 1; idx++) {
			let child = childrenImages[idx];

			child.classList.add("icv__img");
			child.classList.add(idx === 0 ? `icv__img-a` : `icv__img-b`);

			if (idx === 1) {
				let wrapper = document.createElement("div");
				let afterUrl = childrenImages[1].src;
				wrapper.classList.add("icv__wrapper");
				wrapper.style.cssText = `
			  width: ${100 - this.settings.startingPoint}%;
			  height: ${this.settings.startingPoint}%;

			  ${"ontouchstart" in document.documentElement
						? ``
						: this.settings.smoothing
							? `transition: ${this.settings.smoothingAmount}ms ease-out;`
							: ``
					}
			  ${this.settings.fluidMode &&
					`background-image: url(${afterUrl}); clip-path: inset(${this.settings.verticalMode
						? ` 0 0 ${100 - this.settings.startingPoint}% 0`
						: `0 0 0 ${this.settings.startingPoint}%`
					})`
					}
		  `;

				wrapper.appendChild(child);
				this.wrapper = wrapper;
				this.el.appendChild(this.wrapper);
			}
		}
		if (this.settings.fluidMode) {
			let url = childrenImages[0].src;
			let fluidWrapper = document.createElement("div");
			fluidWrapper.classList.add("icv__fluidwrapper");
			fluidWrapper.style.cssText = `

		  background-image: url(${url});

		`;
			this.el.appendChild(fluidWrapper);
		}
	}
}


let serverIP = 'localhost';

window.lightSwarmServerIP = serverIP;

function turnOnApt(number) {
	jQuery.ajax({
		url: 'http://' + window.lightSwarmServerIP + ':3000/apt?number=' + (number),
		type: 'POST',
		success: function (result) {
			console.log(result)
		},
		error: function (err) {
			console.error(err);
		}
	});
}

function turnOnLevel(number) {
	jQuery.ajax({
		url: 'http://' + window.lightSwarmServerIP + ':3000/group?number=' + (number),
		type: 'POST',
		success: function (result) {
			console.log(result)
		},
		error: function (err) {
			console.error(err);
		}
	});
}

function allOff() {
	return new Promise((resolve, reject) => {
		jQuery.ajax({
			url: 'http://' + window.lightSwarmServerIP + ':3000/allOff',
			type: 'POST',
			success: function (result) {
				resolve(result);
			},
			error: function (err) {
				reject(err);
			}
		});
	});

}

function allOn() {
	return new Promise((resolve, reject) => {
		jQuery.ajax({
			url: 'http://' + window.lightSwarmServerIP + ':3000/allOn',
			type: 'POST',
			success: function (result) {
				resolve(result);
			},
			error: function (err) {
				reject(err);
			}
		});
	});

}

function getCursorPos(e, parent) {
	var parentOffset = jQuery(parent).offset();
	var relX = e.pageX - parentOffset.left;
	var relY = e.pageY - parentOffset.top;
	return { x: relX, y: relY };
}